import { action } from 'mobx';
import { SessionStore } from './session.store';
import { AggregateFunction, AgtAnalyticsStore, SelectColumn } from './agt.analytics.store';

export interface IAgtStsModel {
	vtnrId: number;
	bm: number;
	year: number;
	bid: string;
	vorname: string;
	nachname: string;
	basic: number;
	mc: number;
}

export class StsModel implements IAgtStsModel {
	vtnrId: number;
	bm: number;
	year: number;
	bid: string;
	vorname: string;
	nachname: string;
	basic: number;
	mc: number;
	basicPercent: number;
	mcPercent: number;

	// Legacy compatibility
	agtId: number;

	constructor(data: any) {
		this.vtnrId = data.aid || 0;
		this.bm = data.bm || 0;
		this.year = data.y || 0;
		this.bid = data.bid || '';
		this.vorname = data.v || '';
		this.nachname = data.n || '';
		this.basic = data.basic || 0;
		this.mc = data.mc || 0;

		this.basicPercent = this.basic;
		this.mcPercent = this.mc;

		// Legacy compatibility
		this.agtId = this.vtnrId;
	}
}

export class AgtStsStore extends AgtAnalyticsStore {
	constructor(session: SessionStore) {
		super(session, {
			tableName: 'agentur_sts',
			defaultColumns: [
				{ column: 'vtnr_id', aggregateFunction: AggregateFunction.NONE, alias: 'aid' },
				{ column: 'bm', aggregateFunction: AggregateFunction.NONE },
				{ column: 'year', aggregateFunction: AggregateFunction.NONE, alias: 'y' },
				{ column: 'bid', aggregateFunction: AggregateFunction.NONE },
				{ column: 'vorname', aggregateFunction: AggregateFunction.NONE, alias: 'v' },
				{ column: 'nachname', aggregateFunction: AggregateFunction.NONE, alias: 'n' },
				{ column: 'basic', aggregateFunction: AggregateFunction.NONE },
				{ column: 'mc', aggregateFunction: AggregateFunction.NONE },
			],
		});
		this.queryName = '?sts';
	}

	@action
	async loadAll(): Promise<StsModel[]> {
		const results = await this.query(this.config.defaultColumns);
		return results.map((data) => new StsModel(data));
	}

	@action
	async loadByAgtId(agtId: number): Promise<StsModel[]> {
		const whereClause = `a.vtnr_id = ${agtId}`;
		const results = await this.query(this.config.defaultColumns, whereClause);
		return results.map((data) => new StsModel(data));
	}

	async loadByMaxBm(): Promise<StsModel[]> {
		const items = await this.loadAll();

		const maxBmByVtnr = new Map<number, StsModel>();
		for (const item of items) {
			const existing = maxBmByVtnr.get(item.vtnrId);
			if (!existing || item.bm > existing.bm) {
				maxBmByVtnr.set(item.vtnrId, item);
			}
		}

		return Array.from(maxBmByVtnr.values());
	}

	@action
	async loadByBm(bm: number): Promise<StsModel[]> {
		const whereClause = `bm = ${bm}`;
		const results = await this.query(this.config.defaultColumns, whereClause);
		return results.map((data) => new StsModel(data));
	}

	// @action
	// async loadByYear(year: number): Promise<StsModel[]> {
	// 	const whereClause = `year = ${year}`;
	// 	const results = await this.query(this.config.defaultColumns, whereClause);
	// 	return results.map((data) => new StsModel(data));
	// }

	// async getDistinctBms(): Promise<number[]> {
	// 	const selectColumns: SelectColumn[] = [{ column: 'bm', aggregateFunction: AggregateFunction.NONE, distinct: true }];
	// 	const results = await this.query(selectColumns);
	// 	return results.map((data) => parseInt(data.bm)).sort((a, b) => b - a);
	// }



	findByAgtId(agtId: number): StsModel | undefined {
		return this.data.find((i: any) => i.aid === agtId || i.vtnrId === agtId);
	}
}
